import { selector } from "recoil";
import { chequeSettingsFilterState, chequeSettingsState } from "./atoms";

export const filteredChequeSettingsState = selector({
    key: 'filteredChequeSettingsState',
    get: ({ get }) => {
        const filter = get(chequeSettingsFilterState)
        const chequeSettings = get(chequeSettingsState)
        return chequeSettings.filter(chequeSetting => chequeSetting.title.includes(filter))
    }
})